export default __webpack_public_path__ + "assets/new-window-22cdfc5b50fb280d54b669cf3c8d5ef9.svg";